import React, { createContext, useContext, useState, type ReactNode } from 'react'

interface StickyTopContextValue {
  isSticky: boolean | null
  setSticky: React.Dispatch<React.SetStateAction<boolean | null>>
  lockHeaderScroll: boolean
  setLockHeaderScroll: React.Dispatch<React.SetStateAction<boolean>>
}

const StickyTopContext = createContext<StickyTopContextValue | undefined>(undefined)

interface StickyTopProviderProps {
  children: ReactNode
}

const StickyTopProvider: React.FC<StickyTopProviderProps> = ({ children }) => {
  const [isSticky, setSticky] = useState<boolean | null>(null)
  const [lockHeaderScroll, setLockHeaderScroll] = useState(false)

  return (
    <StickyTopContext.Provider value={{ isSticky, setSticky, lockHeaderScroll, setLockHeaderScroll }}>
      {children}
    </StickyTopContext.Provider>
  )
}

export const useStickyTop = (): StickyTopContextValue => {
  const context = useContext(StickyTopContext)

  if (!context) {
    throw new Error('useStickyTop must be used within a StickyTopProvider')
  }

  return context
}

export { StickyTopProvider, StickyTopContext }
